angular.module("Main").factory("AggregatorService", ["$http", "$q", "NODEBACKEND", "SessionCache","SessionService",
    function ($http, $q, NODEBACKEND, SessionCache, SessionService) {


        return {
            checkAggregatorenLinkConfig: checkAggregatorenLinkConfig,

        };

        function checkAggregatorenLinkConfig(id) {
            return $http.get(NODEBACKEND + "/booking/aggregator/get/" + id).then(function (response) {
                return response.data;
            })
        }


    }]);